const getBlack = (alpha: string) => `rgba(0, 0, 0, ${alpha || '1'})`;
const getGray = (alpha: string) => `rgba(33, 33, 33, ${alpha || '1'})`;

export const COLORS = {
  BLUE: '#007BFF', // PRIMARY
  BLUE_50: '#E8E9FF',
  BLUE_DARK: '#335FFF',
  GREEN: '#2E7B32', // SUCCESS
  YELLOW: '#FFB400', // WARNING
  RED: '#F44336', // DANGER
  BLACK: '#495057', // DARK
  BLACK_DARK: '#3D5170',
  BLACK_LIGHT: '#5A6169', // SECONDARY
  BLACK_08: getBlack('.08'),
  BLACK_3: getBlack('.3'),
  BLACK_6: getBlack('.6'),
  BLACK_12: getBlack('.12'),
  BLACK_87: getBlack('.87'),
  GRAY: '#E5E5E5', // LIGHT
  GRAY_08: getGray('.08'),
  GRAY_BORDER: '#BECAD6',
  GRAY_ICON: '#ABB6BF',
  GRAY_BORDER_HOVER: '#8FA4B8',
  GRAY_CAPTION: '#868E96',
  GRAY_LIGHT: '#818EA3',
  GRAY_LIGHTER: '#B9BBBE',
  GRAY_MEDIUM: '',
  GRAY_DARK: '#DADADA',
  WHITE: '#FFFFFF',
  OFF_WHITE: '#F7FAFC',
};

export const FONTS = "'Roboto', sans-serif";

export const BOX_SHADOWS = {
  default: `0 0.7px 1.8px hsla(227, 15%, 0%, 0.008),
    0 1.6px 4.3px hsla(227, 15%, 0%, 0.012),
    0 3px 8px hsla(227, 15%, 0%, 0.015),
    0 5.4px 14.3px hsla(227, 15%, 0%, 0.018),
    0 10px 26.7px hsla(227, 15%, 0%, 0.022),
    0 24px 64px hsla(227, 15%, 0%, 0.03)`,
  input: `0px 5px 11px rgba(0, 123, 255, 0.1),
    0px 2px 2px rgba(0, 0, 0, 0.06);`,
  card: `
    0px 0.7px 1.8px rgba(0, 0, 0, 8e-05),
    0px 1.6px 4.3px ${getBlack('0.012')},
    0px 3px 8px ${getBlack('0.015')},
    0px 5.4px 14.3px ${getBlack('0.018')},
    0px 10px 26.7px ${getBlack('0.022')},
    0px 24px 64px ${getBlack('0.03')};
  `,
  divider: `
    inset 0px 1px 0px ${COLORS.BLACK_08}
  `,
};
